import WRAP from "WRAP-JS";

const LINE_JOIN = ['round', 'bevel', 'miter'];

const superDrawLines = WRAP.Geo.CanvasContext.prototype._drawLines;
Object.assign(WRAP.Geo.CanvasContext.prototype, {
	/* eslint-disable */
	_drawLines: function(lines, lineWidth, lineDash, strokeStyle, fillStyle, fillImage, option) {
		let org = null;
		if (option && LINE_JOIN.includes(option)) {
			org = this.ctx.lineJoin;
			this.ctx.lineJoin = option;
		}

		if (lines.length > 0 && strokeStyle) {
			const match = /gradient +([^-]+) +- +([^-]+)/g.exec(strokeStyle);
			if (match) {
				const s = lines[0][0];
				const e = lines[0].slice(-1)[0];
				const g = this.ctx.createLinearGradient(s[0], s[1], e[0], e[1]);
				g.addColorStop(0, match[1]);
				g.addColorStop(1, match[2]);
				strokeStyle = g;
			} else if (typeof strokeStyle === 'object' && strokeStyle.type && strokeStyle.type === 'gradation') {
				const s = lines[0][0];
				const e = lines[0].slice(-1)[0];
				const g = this.ctx.createLinearGradient(s[0], s[1], e[0], e[1]);
				const gradations = strokeStyle.opt;
				gradations.forEach(gradation => {
					g.addColorStop(gradation.ratio, gradation.color);
				});
				strokeStyle = g;
			}
		}

		superDrawLines.call(this, lines, lineWidth, lineDash, strokeStyle, fillStyle, fillImage, option);

		if (org !== null) {
			this.ctx.lineJoin = org;
		}
	},
	textMetricsAccurate: function(text, font_size) {
		this.ctx.font = font_size + "px Arial";
		var a = this.ctx.measureText(text);
		return [a.width, a.actualBoundingBoxAscent + a.actualBoundingBoxDescent];
	}
	/* eslint-enable */
});
